type MessageType = 'ict24h-auth-request' | 'ict24h-parent-navigate'

export const sendParentMessage = (type: MessageType, payload?: unknown) => {
  window.parent.postMessage({ type, payload }, '*')
}

export const triggerAuthRequest = () => sendParentMessage('ict24h-auth-request')

export const isParentMessage = (type?: string) =>
  typeof type === 'string' && type.startsWith('ict24h-')

export const sendParentNavigation = (path: string) =>
  sendParentMessage('ict24h-parent-navigate', path)
